<template>
  <div class="calico-list-item">
    <i class="bi bi-caret-right-fill" />
    <div class="content body--medium">
      <slot />
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'CalicoListItem',
  props: {
  },
}
</script>

<style lang="scss">
.calico-list-item {
    @include inline-space($space-small);
    i {
        font-size: $icon-xsmall;
    }
}
</style>
